import React from "react";
import { Route, Routes } from "react-router-dom";
import { Home, AboutUs, Contact, PageNotFound, Accommodation, RoomDetails } from "../pages";

export const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/accommodation" element={<Accommodation />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/roomDetail/:roomType" element={<RoomDetails />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
